<template>
    <div>
        <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="time">
                <el-input v-model="pgData.ggname"  placeholder="招标公告名称" clearable></el-input>
            </el-form-item>
             <el-form-item slot="title">
                 <el-input v-model="pgData.ggcode"  placeholder="招标公告编号" clearable></el-input>
            </el-form-item>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="招标公告编号" prop="ggcode" fixed min-width="200"></el-table-column>
            <el-table-column label="招标公告名称" prop="ggname" min-width="200"></el-table-column>
            <el-table-column label="招标项目编号" prop="zbprocode" width="200"></el-table-column>
            <el-table-column label="招标项目名称" prop="zbproname" width="200"></el-table-column>
            <el-table-column label="添加时间" prop="addtime" sortable width="160"></el-table-column>
            <el-table-column label="添加人" prop="addusername" width="140"></el-table-column>
            <el-table-column label="操作" width="100" fixed="right">
                <template slot-scope="scope">
                    <el-button
                    type="text"
                    icon="el-icon-warning"
                    @click="editHandler({ggcode:scope.row.ggcode})">
                        退回
                    </el-button>
                </template>
            </el-table-column>
        </my-table>

        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('mngUrl')}/Zbdl/tuihui/get_zbggList.json`">
        </my-pagination>

        <my-dialog 
        title="退回" 
        v-model="dialogVisible" 
        width="500px"
        >
            <form-page 
                v-if="dialogVisible"
                :data="form"
                @cancle="dialogClose"
            ></form-page>
        </my-dialog>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'

import FormPage from './form'

export default {
    mixins: [LIST_PAGE_MIXIN, DIALOG_LIST_PAGE_MIXIN],
    components: { FormPage },
    data() {
        return {
            pgData: {
                sortname: 'addtime',
                sortorder: 'desc',
                pagesize: 20,
                ggname:'',
                ggcode:''

            },

            form: {}
        }
    },
    methods: {
        
    },
    created() {
 
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
</style>
